import moment from "moment";

const momentTimeZone = require("moment-timezone");

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat("en-IN").format(num);
};

export const formatNumberWithCommas = (number: number | string = 0) => {
  if (String(number) === "NaN") {
    return 0;
  }
  return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumberWithoutCommas = (number: number | string = 0) => {
  return parseFloat(String(number).replace(/,/g, ""));
};

export const formatDateStringTo2Row = (date: string = "") => {
  const arr = String(date).split(" ");
  return `${arr[0]} <br/> ${arr[1]}`;
};

export const formatQueryParams = (query: any = {}) => {
  const clone = structuredClone(query);
  delete clone.time_request;
  delete clone.time_request_out;
  delete clone.time_request_inner;
  // if (query?.sort_by && (String(query?.sort_by)?.includes('_') || String(query?.sort_by)?.includes('At'))) {
  //     const arr_sort_by = String(query?.sort_by)?.split('_');
  //     const join_sort_by = arr_sort_by?.map((sort: string) => `[${sort}]`).join('');
  //     clone[`sort${join_sort_by}`] = String(query?.order_by || 'desc').toLocaleLowerCase();

  //     delete clone.sort_by;
  //     delete clone.order_by;
  // }
  return clone;
};

export const formatLinkHTTPS = (linkString: string = "") => {
  if (
    String(linkString).includes("https://") ||
    String(linkString).includes("http://")
  ) {
    return linkString;
  }
  return `https://${linkString}`;
};

export const renderUrlSearchKeywordInNaver = (keyword: string = "") => {
  return `https://search.naver.com/search.naver?where=nexearch&sm=top_hty&fbm=0&ie=utf8&query=${keyword}`;
};

export const renderUrlSearchLookingUpByIP = (ip: string = "") => {
  return `https://whatismyipaddress.com/ip/${ip}`;
};

export const formatDateStringToKorea = (dateString: string = "") => {
  if (!dateString) return "";
  var utcCutoff = moment.tz(dateString, "UTC");
  const date = momentTimeZone(utcCutoff)
    .tz("Asia/Seoul")
    .format("YYYY-MM-DD HH:mm:ss");

  return date;
};

export const formatISOString = (date: any, type: "start" | "end") => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;

  const localDate = new Date(date);
  if (type === "start") {
    localDate.setHours(0, 0, 0, 0);
  } else {
    localDate.setHours(23, 59, 59, 999);
  }

  return new Date(
    new Date(localDate).getTime() - (9 - offsetHours) * 60 * 60 * 1000
  ).toISOString();
};

export const formatTimeISOString = (date: any) => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;

  return new Date(
    new Date(date).getTime() - (9 - offsetHours) * 60 * 60 * 1000
  ).toISOString();
};

export const formatDateStringToUTC = (dateString: string = "") => {
  if (!dateString) return "";
  var utcCutoff = moment.tz(dateString, "Asia/Seoul");
  const date = momentTimeZone(utcCutoff)
    .tz("UTC")
    .format("YYYY-MM-DD HH:mm:ss");

  return date;
};

export const formatSummaryStatistics = (data: any) => {
  const data_format = data?.combined?.map((item: any) => ({
    ...item,
    service: {
      hot: data?.hot?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      wallpaper: data?.wallpaper?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      snap: data?.snap?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      photoCardNews: data?.photoCardNews?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
    },
  }));
  const data_total = {
    date: "",
    totalLikes: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalLikes) + total,
      0
    ),
    totalViews: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalViews) + total,
      0
    ),
    totalShares: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalShares) + total,
      0
    ),
    totalComments: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalComments) + total,
      0
    ),
    totalDownloads: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalDownloads) + total,
      0
    ),
  };
  return {
    data: data_format,
    total: data_total,
  };
};
